// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_un-0";
export var checkoutRateBadgeLink = "_un-1";